import { expValEquals } from '@confluence/feature-experiments';
import {
	useGetOnboardingState,
	deserializeState,
} from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState';
import {
	LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA,
	FOUNDING_ADMIN_WITH_REVAMPED_BPQA,
} from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants';
import { useIsLicensed } from '@confluence/session-data/entry-points/useAccessStatus';

import { isWithinLastWeek } from '../utils/isWithinLastWeek';
import { fg } from '@confluence/feature-gating';

export const useShouldShowNewUserTemplates = () => {
	const isLicensed = useIsLicensed();

	const { data, loading, error } = useGetOnboardingState(
		[FOUNDING_ADMIN_WITH_REVAMPED_BPQA, ...Object.values(LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA)],
		!isLicensed,
	);
	const { revampedBpqaShownAt, showRevampedBpqaForFoundingAdmin } = deserializeState(data);
	const shownAtWithinLastWeek = isWithinLastWeek(revampedBpqaShownAt);

	if (!isLicensed) {
		return { showNewUserTemplates: false, loading: false };
	}

	if (loading) {
		return { showNewUserTemplates: false, loading: true };
	}

	if (error) {
		return { showNewUserTemplates: false, loading: false, error };
	}

	return {
		showNewUserTemplates:
			(showRevampedBpqaForFoundingAdmin && fg('cfind-4971-improved-templates-bar-gate')) ||
			(shownAtWithinLastWeek &&
				(expValEquals('land_users_in_editor_with_revamped_bpqa_new', 'cohort', 'experiment') ||
					expValEquals(
						'land_users_in_editor_with_revamped_bpqa_existing',
						'cohort',
						'experiment',
					))),
		loading: false,
	};
};
